import { Box, CircularProgress } from "@mui/material";
import ThreeDotsLoading from "./ThreeDotsLoading";

const LoadingIcon = ({ type = "dots", ...props }) => {
  return (
    <Box
      display="flex"
      height={"100%"}
      alignItems="center"
      justifyContent="center"
    >
      {type === "circular" ? (
        <CircularProgress {...props} />
      ) : (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <ThreeDotsLoading {...props} />
        </Box>
      )}
    </Box>
  );
};

export default LoadingIcon;
